<ion-grid>
  <ion-row>
    <ion-col>
      <ul>
        <li *ngFor="let tab of dashboardTabs; index as i">
          <a
            *ngIf="!tab.isActive; else tabSpan"
            id="tab-link-{{ i }}"
            [attr.data-cy]="'tab-' + (tab.label | translate) + '-link'"
            [routerLink]="tab.url"
            translate
            >{{ tab.label | translate }}
          </a>
          <ng-template #tabSpan>
            <span data-cy="tab-active-link" translate>{{
              tab.label | translate
            }}</span>
          </ng-template>
        </li>
      </ul>
    </ion-col>
  </ion-row>
</ion-grid>
